import configurationService from "@/api/configurationService";
import router from '@/router/index';

const state= {
    configurations: [],
    loader: false,
    initialData: {},
    metadata: {},
    editId: null,
    newConfiguration: {},
    newDBDetail: {}
}
const getters = {
  getEditConfiguration: state => state.newConfiguration,
  getEditDBDetail: state => state.newDBDetail
}
const actions = {
  async getConfigurations({ commit,state }) {
    state.loader = true;
    const response = await configurationService.getConfiguration();
    state.loader=false
    commit('get', response.data)
  },
  async getInitialData({commit, state}) {
    state.loader=true
    const response = await configurationService.getInitialData();
    state.loader=false
    commit('getInitialData', response.data)
  },
  async addConfiguration({ commit }, configuration) {
    const response = await configurationService.addConfiguration(configuration);
    if (response.data.status) {
        commit('addConfiguration', response.data.result, { root: true });
    } 
    return response.data;
  },
  async editConfiguration({ commit }, configuration) {
    commit('edit', configuration);//response.data.result)
  },
  async editDBDetail({ commit }, DBDetail) {
    commit('editDBDetail', DBDetail);//response.data.result)
  },
  async updateConfiguration({ commit }, configuration) {
    const response = await configurationService.updateConfiguration(state.editId, configuration);
    commit('updateConfiguration', response.data.result, { root: true });
    return response.data;
  },
  async deleteConfiguration({ commit }, configuration) {
    await configurationService.deleteConfiguration(configuration.dataItem.id);
    commit('removeConfiguration', configuration.dataItem.id, { root: true });
  },
  async addDBDetail({ commit }, DBDetail) {
    const response = await configurationService.addDBDetail(DBDetail);
    if (response.data.status) {
        commit('addDBDetail', response.data.result, { root: true });
    } 
    return response.data;
  },
  async updateDBDetail({ commit }, DBDetail) {
    const response = await configurationService.updateDBDetail(state.editId, DBDetail);
    commit('updateDBDetail', response.data.result, { root: true });
    return response.data;
  },
}
const mutations = {
  get(state, configurations) {
    state.configurations = configurations;
    state.filteredDevices = configurations;
  },
  edit(state, configuration) {
    state.editId = configuration.id
    state.newConfiguration = configuration
    state.metadata = configuration.metaData ? configuration.metaData : {}
    router.push({ name: "configurationAddUpdate", params: { add: false } });
  },
  editDBDetail(state, DBDetail) {
    state.editId = DBDetail.id,
    state.newDBDetail= DBDetail
    state.metadata = DBDetail.metaData ? DBDetail.metaData : {}
    router.push({ name: "DBAddUpdate", params: { add: false } });
  },
  getInitialData(state, data) {
    state.initialData = data;
  },
  cancel(state) {
    state.metadata = {}
  },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}